import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { MessagesGetResultApi } from 'api-typings/messages/messages_types';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    messages: MessagesGetResultApi;
  }
}

export const messagesBackend: Backend<'messages'> = {
  fetch: (_, key2, query) => ({
    endpoint: `messages/0.1/messages`,
    params: {
      threads: query ? getQueryParamValue(query, 'threadId') : [],
      thread_details: 'true',
      user_details: 'true',
    },
  }),
  post: (_, entity) => ({
    endpoint: `messages/0.1/threads/${entity.threadId}/messages/`,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/messages/messages.backend.ts